import styled from 'styled-components';

import { colors, cssBreakpoints, gutterWidth, maxWidth } from 'theme/theme';

export const ListingViewFooterHolder = styled.div<{
  $hiddenOnDesktop: boolean;
}>`
  margin-top: 70px;
  padding: 70px 0;
  text-align: center;
  background: ${colors.backgroundGrey};

  @media all and (max-width: ${cssBreakpoints.lgDown}) {
    padding: 70px 0;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: ${(props) => (props.$hiddenOnDesktop ? 'none' : undefined)};
  }

  @media print {
    display: none;
  }
`;

export const ListingViewFooterWrapper = styled.div`
  margin: 0 auto;
  max-width: ${maxWidth[3]}px;

  @media all and (max-width: ${cssBreakpoints.lgUp}) {
    padding: 0 ${gutterWidth}px;
  }
`;
